import { UserImportedRanking } from 'models/ranking/importedRanking/UserImportedRanking';

export class UserImportedRankingService {
	toModel(ranking) {
		return new UserImportedRanking(ranking);
	}
}
